export default __webpack_public_path__ + "static/media/best-sicilian-food.4e49e007.jpg";